<ng-container>
    <div id="areaTotal" [class]="fullscreen?'fullscreen':'displayBlock'">
        <suite-rfb-alert-messages *ngIf="fullscreen"></suite-rfb-alert-messages>
        <div class="titulo-pagina" *ngIf="fullscreen">{{ tituloPagina }} - edição dos segmentos</div>
        <div class="top-toolbox" (mouseover)="closeAllToolbars()">
            <div *ngIf="!readonly">
                <select *ngIf="tipo === '16'" style="width: 145px">
                    <option value="16" selected>
                        Anexo
                    </option>
                </select>
                <select [(ngModel)]="tipo" (change)="changeTipoSegmento()" *ngIf="tipo !== '16'" style="width: 145px">
                    <option *ngFor="let tipo of tiposSegmentoFiltrados" [value]="tipo.idTipoSegmento">
                        {{ tipo.nomeTipoSegmento }}
                    </option>
                </select>
                <select [(ngModel)]="idAssunto" (change)="changeAssunto()" style="width: 170px">
                    <option *ngFor="let assunto of assuntos" [value]="assunto.idAssunto">
                        {{ assunto.nomeAssunto }}
                    </option>
                </select>

                <!-- <ng-container *ngIf="ambiente.ambiente === 'loc'">

                    Estes botões foram implementados, porém não há requisitos definidos e não houve homologação pelo cliente.
                    * Formatar fonte - a implementação atual se limita a 3 tipos de fonte.
                    * Formatar tamanho do texto - a implementação atual se limita a 4 tamanhos de fonte.
                    * Formatar cor do texto - a implementação atual permite alteração em quantidade e definição de cores.
                    Alterações em tipo e tamanho de fonte podem necessitar códigos específicos de módulos adicionais do Quill.

                    <span class="toolbar-button" (mouseover)="toolbarMouseOver($event)">
                        <button type="button" class="material-icons icon-18" title="Formatar fonte" (click)="openToolbar(0)">title</button>
                        <span class="toolbar-options" *ngIf="toolbarOpened[0]">
                            <option *ngFor="let opt of fontFamilies, let i = index"
                                    (click)="formatFontFamily(i)">
                                {{ opt.texto }}
                            </option>
                        </span>
                    </span>

                    <span class="toolbar-button" (mouseover)="toolbarMouseOver($event)">
                        <button type="button" class="material-icons icon-18" title="Formatar tamanho do texto" (click)="openToolbar(1)">format_size</button>
                        <span class="toolbar-options" *ngIf="toolbarOpened[1]">
                            <option *ngFor="let opt of fontSizes, let i = index"
                                    (click)="formatFontSize(i)">
                                {{ opt.texto }}
                            </option>
                        </span>
                    </span>

                    <span class="toolbar-button" (mouseover)="toolbarMouseOver($event)">
                        <button type="button" class="material-icons icon-18" title="Formatar cor do texto" (click)="openToolbar(2)">format_color_text</button>
                        <span class="toolbar-options" *ngIf="toolbarOpened[2]">
                            <span class="font-color" *ngFor="let opt of fontColors, let i = index"
                                    [style]="{ 'background-color': opt.texto }"
                                    (click)="formatFontColor(i)">
                                &nbsp;
                            </span>
                        </span>
                    </span>
                </ng-container> -->

                <button class="material-icons icon-18" title="Formatar negrito" (click)="format('bold')">format_bold</button>
                <button class="material-icons icon-18" title="Formatar itálico" (click)="format('italic')">format_italic</button>
                <button class="material-icons icon-18" title="Formatar sublinhado" (click)="format('underline')">format_underlined</button>

                <button class="material-icons icon-18" title="Formatar subescrito" (click)="formatText('sub')">subscript</button>
                <button class="material-icons icon-18" title="Formatar sobrescrito" (click)="formatText('super')">superscript</button>

                <button class="material-icons icon-18" title="Remover formatação" (click)="removeFormat()">format_clear</button>
                <!--
                    Estes botões têm implementação mas foram desativados para dar lugar à funcionalidade de Confeccionar Luds.

                    <button class="material-icons icon-18" title="Configurar link" (click)="formatAddLink($event)">link</button>
                    <button class="material-icons icon-18" title="Excluir link" (click)="formatRemoveLink()">link_off</button>
                 -->
                <button class="material-icons icon-18 dropdown-button" title="Incluir anexo" (click)="toolboxIncluirAnexo()">file_present</button>
                <input type="file" #inputFileAnexo class="invisivel"
                    accept=".jpg, .jpeg, .gif, .htm, .html, .pdf, .doc, .xls, .ppt, .pps, .docx, .xlsx, .pptx, .ppsx, .odt, .stw, .ods, .odp"
                    (change)="onFileChange($event)">

                <button class="material-icons botao-com-imagem" title="Incluir segmento" (click)="formatAddSegment()">
                    <img src="/assets/imagens/incluir-segmento.png">
                </button>
                <button class="material-icons botao-com-imagem" title="Excluir segmento" (click)="formatRemoveSegment()">
                    <img src="/assets/imagens/excluir-segmento.png">
                </button>
                <button class="material-icons icon-18" title="Configurar segmento" (click)="formatEstiloSegmento()">tune</button>
                <button class="material-icons icon-18" title="Confeccionar LUDs" (click)="abrirConfeccaoLUDs()">dataset_linked</button>

                <button class="material-icons icon-18" style="float:right" title="Exibir em tela cheia" (click)="fullscreen=true" *ngIf="!fullscreen">fullscreen</button>
                <button class="material-icons icon-18" style="float:right" title="Restaurar visão" (click)="fullscreen=false" *ngIf="fullscreen">close_fullscreen</button>
            </div>
        </div>
        <div id="conteudoAto2" #conteudoAto2 [class]="fullscreen ? 'area-edicao tela-maxima' : 'area-edicao tamanho-fixo'" (mouseover)="closeAllToolbars()">
            <div class="row">
                <div class="col-md-12">
                    <div *ngFor="let segmento of segmentos; let idx = index"
                            [style]="segmento.idTipoSegmento === 1 ? {width: '50%', float: 'right', clear: 'right'} : {width: '100%', clear: 'right'}">
                        <div [id]="'segmento'+idx"
                                [style]="borderStyle(segmento)"
                                [class]="classeEditor(idx, segmento)">
                            <div *ngIf="segmento.anexoInconsistente && segmento.idTipoSegmento !== 16" class="mensagem-anexo-inconsistente">
                                O segmento não é do tipo Anexo, mas contém um arquivo.
                            </div>
                            <div *ngIf="segmento.anexoInconsistente && segmento.idTipoSegmento === 16" class="mensagem-anexo-inconsistente">
                                O segmento é do tipo Anexo, mas não contém um arquivo.
                            </div>
                            <div
                                    class="segmento2" [style.borderWidth]="'1px'" [style]="segmento.style"
                                    *ngIf="!segmento.arquivoBinario && (!segmento.visivel && idx !== currentSegment)">
                                <span [innerHTML]="segmento.textoIntegra"></span>
                            </div>
                            <div *ngIf="!segmento.arquivoBinario && (segmento.visivel || idx === currentSegment)">
                                <quill-editor
                                        placeholder="(segmento vazio)"
                                        [styles]="segmento.style"
                                        [style.width]="'100%'"
                                        [(ngModel)]="segmento.textoIntegra"
                                        [modules]="{ toolbar: false }"
                                        (onEditorCreated)="onEditorCreated($event, idx)"
                                        (onFocus)="onFocusEditor($event, idx)"
                                        (paste)="paste($event)"
                                        (keyup)="keyUpEditor($event)"
                                        [readOnly]="readonly">
                                </quill-editor>
                                <div *ngIf="segmento.anexoInconsistente">
                                    <em class="material-icons icon-24" style="color: red;">file_present</em>
                                    <span style="color: red;">Anexo não existente</span>
                                    <div>
                                        <button type="button" class="btn btn-primary"
                                            (click)="uploadAnexoParaSegmentoDeTipoInconsistente(idx)">
                                            Fazer upload
                                        </button>
                                        <button type="button" class="btn btn-primary"
                                            (click)="trocarTipoSegmentoInconsistenteParaTipoOrdinario(segmento)">
                                            Transformar em segmento comum
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div [id]="'segmento'+idx" *ngIf="segmento.arquivoBinario" [style]="segmento.anexoInconsistente ? '' : segmento.style" (click)="onFocusEditor(null, idx)">
                                <input type="text" id="input-invisivel" *ngIf="currentSegment === idx">
                                <div class="envelope-tabela-anexa" [innerHTML]="getInnerHtmlTabela(segmento)" *ngIf="[4,5].indexOf(segmento.arquivoBinario.idTipoArquivo) >= 0"></div>
                                <div class="inner-imagem" *ngIf="[2,3].indexOf(segmento.arquivoBinario.idTipoArquivo) >= 0">
                                    <img [src]="'data:image;base64,'+segmento.arquivoBinario.arquivoBinario" alt="imagem">
                                </div>
                                <div class="anexo-ancora" *ngIf="[2,3,4,5].indexOf(segmento.arquivoBinario.idTipoArquivo) < 0">
                                    <em class="material-icons icon-18">file_present</em> {{ segmento.arquivoBinario.nomeArquivoBinario }}
                                </div>
                                <div class="auxiliar-anexo">
                                    <a (click)="baixarAnexo(segmento)" title="Baixar o arquivo">
                                        <em class="material-icons icon-18">download</em>
                                    </a>
                                    <a (click)="toolboxSubstituirAnexo()" title="Substituir o arquivo">
                                        <em class="material-icons icon-18">upload</em>
                                    </a>
                                    ::&nbsp;<input type="text" [(ngModel)]="segmento.textoIntegra" [readonly]="readonly">
                                </div>
                                <div *ngIf="segmento.anexoInconsistente">
                                    <button type="button" class="btn btn-primary"
                                        (click)="removerAnexoDeSegmentoDeTipoInconsistente(segmento)">
                                        Remover arquivo anexo
                                    </button>
                                    <button type="button" class="btn btn-primary"
                                        (click)="trocarTipoSegmentoInconsistenteParaAnexo(segmento)">
                                        Transformar em segmento do tipo Anexo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="fullscreen">
            <ng-container *ngTemplateOutlet="botoes"></ng-container>
        </ng-container>
    </div>
</ng-container>
<ng-template #botoes>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="clickSalvar()">Salvar</button>
                <button type="button" class="btn btn-default" (click)="clickCancelar()" *ngIf="!fullscreen">Cancelar</button>
            </div>
        </div>
    </div>
</ng-template>

<div class="modal-area-morta" *ngIf="exibirModalAddLink" (keyup)="$event.preventDefault()" role="dialog">
    <div class="modal-add-link" cdkDrag>
        <div class="modal-content">
            <div class="modal-header" cdkDragHandle>
                <h4 class="modal-title pull-left">
                    Editar link
                </h4>
            </div>
            <div class="modal-body">
                <form>
                    <div class="alert alert-warning erro-modal"
                            *ngIf="erroModal"
                            (click)="erroModal = ''">
                        {{ erroModal }}
                    </div>
                    <div class="row">
                        <div class="form-group">
                            <div class="col-sm-12">
                                <label for="url" class="control-label">URL</label>
                                <input #addLinkUrlCtrl="ngModel" type="text" name="url" id="url" class="form-control" [(ngModel)]="addLinkUrl"
                                style="height: 25px;" (keyup)="keyupUrl($event)">
                                <suite-rfb-local-messages [control]="addLinkUrlCtrl"></suite-rfb-local-messages>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" title="Cancelar" class="btn btn-default"
                        (click)="cancelarAddLink()">
                    Cancelar
                </button>
                <button type="button" title="Confirmar" class="btn btn-primary"
                        (click)="confirmarAddLink()">
                    Confirmar
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-area-morta" *ngIf="exibirModalAlerta" (keyup)="$event.preventDefault()" role="dialog">
    <div class="modal-add-link" cdkDrag>
        <div class="modal-content">
            <div class="modal-header" cdkDragHandle>
                <h4 class="modal-title pull-left">
                    Alerta
                </h4>
            </div>
            <div class="modal-body">
                {{ mensagemAlerta }}
            </div>
            <div class="modal-footer">
                <button type="button" title="Cancelar" class="btn btn-primary"
                        (click)="exibirModalAlerta = false">
                    Ciente
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-area-morta" *ngIf="exibirModalEstiloSegmento"
        (keypress)="$event.stopPropagation()"
        (keyup)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        role="dialog">
    <div class="modal-estilo-segmento" cdkDrag>
        <div class="modal-content">
            <div class="modal-header" cdkDragHandle>
                <h4 class="modal-title pull-left">
                    Configurar estilo do segmento
                </h4>
            </div>
            <div class="modal-body">
                <app-painel-estilo-segmento
                        [tipoSegmento]="tipoSegmento"
                        [tipoSegmentoGlobal]="tipoSegmentoGlobal"
                        [segmento]="segmentoSelecionado"
                        [readonly]="false"
                        (aplicarEstiloSegmento)="aplicarEstilo($event)">
                </app-painel-estilo-segmento>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="exibirConfeccionarLUDs">
    <app-confeccionar-luds
            [segmentos]="segmentosParaLUDs"
            (fechar)="fecharConfeccaoLUDs($event)">
    </app-confeccionar-luds>
</ng-container>
